import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MainPage from './pages/MainPage';
import AdminDashboard from './pages/AdminDashboard';
import GiftCardSystem from './components/GiftCardSystem';
import MainLayout from './layouts/MainLayout';
import { MentionsLegales, PolitiqueConfidentialite, PolitiqueCookies, CGV } from './pages/LegalPages';
import services from './data/services';

function App() {
  const [selectedService, setSelectedService] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleServiceSelect = (service, category) => {
    setSelectedService(service);
    setSelectedCategory(category);
  };
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MainLayout services={services} onServiceSelect={handleServiceSelect}/>} >
          <Route path="/" element={<MainPage services={services} selectedService={selectedService} selectedCategory={selectedCategory} />} />
          <Route path="/cartes-cadeaux" element={<GiftCardSystem />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/politique-cookies" element={<PolitiqueCookies />} />
          <Route path="/cgv" element={<CGV />} />
        </Route>
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;